"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAtClientSide = exports.__postAjaxClient = exports.__getAjaxClient = exports.__getApiClient = exports._format_api_error = void 0;
const constants_1 = require("../../constants");
const jwt_1 = require("../../jwt");
const helpers_1 = require("../../helpers");
const env_config_1 = __importDefault(require("../../env.config"));
const auth_1 = __importDefault(require("../../auth"));
function handle401Error() {
    return __awaiter(this, void 0, void 0, function* () {
        yield auth_1.default.getInstance().destroy();
        yield auth_1.default.getInstance().setAuth();
    });
}
const getApiHeaders = () => __awaiter(void 0, void 0, void 0, function* () {
    // const { authToken, source, deviceUUID } =
    const cookies = (0, helpers_1.parseCookies)();
    const jwt = new jwt_1.Jwt();
    const jwt_data = auth_1.default.getInstance().auth;
    //todo fix static aud
    const auth = auth_1.default.getInstance();
    const aud = auth.platform || (0, helpers_1.getQueryStringValue)('platform');
    //todo fix user identity
    const userInfo = (0, helpers_1.jsonSafeGet)(cookies[env_config_1.default.COOKIES_PREFIX + 'userInfo']);
    // console.log({
    //     kV2: jsonSafeGet(cookies[CookiesConstants.AUTH_V2])?.['k'],
    //     k: jsonSafeGet(cookies[CookiesConstants.AUTH])?.['k'],
    //     tgtTicket
    // })
    // console.log({
    //     tgtTicket,
    //     payLoad: {
    //         at0,
    //         aud,
    //         sub: userInfo && userInfo.id ? userInfo.id : deviceUUID
    //     }
    // })
    const token = yield jwt.generate_jwt(jwt_data.k, {
        at0: jwt_data.t,
        aud,
        sub: userInfo && userInfo.id ? userInfo.id : jwt_data.deviceUUID
    });
    let headers = {
        source: aud,
        country: auth.country || (0, helpers_1.getQueryStringValue)('country'),
        "accept-language": auth.language || (0, helpers_1.getQueryStringValue)('language'),
        "release-version": constants_1.API_HEADERS_CONSTANTS.RELEASE_VERSION,
    };
    headers = Object.assign(Object.assign({}, headers), {
        Authorization: "Bearer " + token,
        "x-tracking-uuid": jwt_data.deviceUUID,
    });
    return headers;
});
function _format_api_error(errorMessage, statusCode) {
    return Object.assign(Object.assign({}, errorMessage), { isValidationError: () => statusCode === 422, toValidationErrorMsg: () => {
            if (Array.isArray(errorMessage)) {
                return errorMessage.reduce((state, currentVal) => {
                    state[currentVal.field] = currentVal.message;
                    return state;
                }, {});
            }
            else {
                return errorMessage;
            }
        } });
}
exports._format_api_error = _format_api_error;
function __fetch_with_error(url, abortController, headers = {}, body = null, method = "GET", shouldHandle401 = true, shouldRetry = true) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = Object.assign(Object.assign({ method }, (method === "POST" ? { body: JSON.stringify(body) } : {})), { 
            // credentials: "include",
            signal: undefined, headers });
        if (abortController) {
            config.signal = abortController.signal;
        }
        // @ts-ignore
        const rawResponse = yield fetch(url, config);
        const json = yield rawResponse.json();
        if (rawResponse.status === 401 && shouldHandle401) {
            yield handle401Error();
            if (shouldRetry) {
                const newHeaders = yield getApiHeaders();
                return __fetch_with_error(url, abortController, newHeaders, body, method, false);
            }
            else
                return;
        }
        if (rawResponse.status >= 400) {
            return Promise.reject(_format_api_error(json, rawResponse.status));
        }
        return json;
    });
}
function __getApiClient(url, abortController, shouldRetry) {
    return __awaiter(this, void 0, void 0, function* () {
        const headers = yield getApiHeaders();
        return __fetch_with_error(url, abortController, headers, null, "GET", true, shouldRetry);
    });
}
exports.__getApiClient = __getApiClient;
function __getAjaxClient(url, abortController) {
    url = `${env_config_1.default.AJAX_API}${url}`;
    return __fetch_with_error(url, abortController);
}
exports.__getAjaxClient = __getAjaxClient;
function __postAjaxClient(url, body, abortController) {
    url = `${env_config_1.default.NODE_API_URL_CLIENT}${url}`;
    return __fetch_with_error(url, abortController, {
        "content-type": "application/json",
    }, body, "POST");
}
exports.__postAjaxClient = __postAjaxClient;
function fetchAtClientSide({ url, body, method = "GET", type, abortController = null, checkErrCallback = (response) => response.status >= 400, shouldRetry = true }) {
    return __awaiter(this, void 0, void 0, function* () {
        if (url[0] === "/") {
            url = url.substring(1, url.length);
        }
        url = `${env_config_1.default.API_URL_CLIENT}/${url}`;
        if (method == "GET") {
            return __getApiClient(url, abortController, shouldRetry);
        }
        else {
            const headers = yield getApiHeaders();
            if ((type === null || type === void 0 ? void 0 : type.toUpperCase()) !== "FILE") {
                headers["Content-Type"] = "application/json";
            }
            // if (type?.toUpperCase() === "SLR_OTP") {
            //     headers["abBucket"] = 1;
            // }
            return new Promise((resolve, reject) => {
                const config = {
                    method,
                    body: (type === null || type === void 0 ? void 0 : type.toUpperCase()) === "FILE" ? body : JSON.stringify(body),
                    cache: "no-cache",
                    // credentials: "include",
                    signal: undefined,
                    headers,
                };
                if (abortController) {
                    config.signal = abortController.signal;
                }
                // @ts-ignore
                fetch(url, config)
                    .then((response) => __awaiter(this, void 0, void 0, function* () {
                    const json = yield response.json();
                    if (checkErrCallback(response)) {
                        return reject(_format_api_error(json, response.status));
                    }
                    resolve(json);
                }))
                    .catch((error) => {
                    console.error("fetchAtClientSide Error:", method, url, error);
                    reject(error);
                });
            });
        }
    });
}
exports.fetchAtClientSide = fetchAtClientSide;
